export const DRY_ICE_REPORT_LABELS = {
  HEADER: $localize`Dry Ice Report`,
  DATE: $localize`Date`,
  ROUTE: $localize`Route`,
};
export const REPORT_FILE_NAME = 'Dry-Ice-Report';
